import Page from "../PublicPage";
import { Password } from "@mui/icons-material";
import useForm from "pages/components/Form/useForm";
import FormFields from "pages/components/FormFields";
import { FormFieldsConfig } from "pages/components/Form/FormEntities";
import { useTranslation } from "react-i18next";
import { ForgotPasswordRequest } from "Domain/User/Dto/ForgotPasswordRequest";
import { ForgotUserPassword } from "Application/User/RegisterService";
import {
  getRoute,
  LOGIN,
  REGISTER,
} from "Infrastructure/config/routesConfig";

export default function ForgotPassword() {
  return (
    <Page
      title={"PUBLIC.title_forgot_password"}
      icon={<Password fontSize="inherit" />}
      links={getFooterLinks()}
    >
      <ForgotPasswordForm />
    </Page>
  );
}

function getFooterLinks() {
  return [
    {
      label: "PUBLIC.link_login",
      url: getRoute(LOGIN),
    },
    {
      label: "PUBLIC.link_not_member_yet",
      url: getRoute(REGISTER),
    },
  ];
}

function ForgotPasswordForm() {
  const { t } = useTranslation();
  function handleSubmit(event: any) {
    event.preventDefault();
    if (isValidForm()) {
      ForgotUserPassword(getForgotPasswordRequest(values));
    }
  }

  const ForgotPasswordFormConfig: FormFieldsConfig = {
    email: {
      constraints: ["email", "required"],
    },
  };

  const {
    errors,
    values,
    isValidForm,
    formatErrorObject,
    handleInputChange,
    Form,
  } = useForm(ForgotPasswordFormConfig, true);

  return (
    <Form onSubmit={handleSubmit}>
      <FormFields.Email
        name="email"
        value={values.email}
        onChange={handleInputChange}
        required
        {...formatErrorObject(errors.email)}
      />
      <FormFields.Button
        type="submit"
        label={t("FORM.SUBMIT.reset_password")}
        fullWidth
        sx={{ mt: 2 }}
      />
    </Form>
  );
}

function getForgotPasswordRequest(values: any) {
  return new ForgotPasswordRequest(values.email);
}
